export function eventAjaxDisplayCmsModal(selector) {
    $(document).on('click', selector, function(e) {
        var id_cms = $(this).attr('data-id-cms');
        if (id_cms) {
            e.preventDefault();
        }  

        $.ajax({
            url: plici_ajax_url,
            type: 'POST',
            data: {
                action: 'getCMSContent',
                ajax: 1,
                id_cms: id_cms
            },
            dataType: 'json'
        }).done(function(data) {

            if (data.content.length > 0) {
                $('#pliciCmsModal .modal-body').html(data.content);
                $('#pliciCmsModal').modal('show');
            }

        }).fail(function(jqXHR, textStatus) {
        });
    });
}